import React, { useState, useRef, useEffect, useCallback } from 'react';
import '../../assets/XMLDataGrid.css'

export function XMLDataGrid({xmlData} ) {
  const [tableData, setTableData] = useState([]);
  const [xmlCurr, setXmlCurr] = useState('');

  const extractTableData = () => {
    const xmlDoc = new DOMParser().parseFromString(xmlData, "application/xml");
    const extractedData = Array.from(xmlDoc.querySelectorAll('var')).map(item => ({
      id: item.getAttribute('name'),
      name: item.querySelector('value')?.innerHTML,
    }));
    return extractedData;
  };

  const updateTable = useCallback(() => {
    if (!xmlData) return;
    if (xmlCurr != xmlData) {
      setTableData(extractTableData());
      setXmlCurr(xmlData);
    }
  });

  useEffect(() => {
    updateTable();
  }, [updateTable]);

  if (!xmlData) return '';

  return (
    <table className='xdg' >
      <thead>
        <tr>
          <th>Name</th>
          <th>Value </th>
        </tr>
      </thead>
      <tbody>
        {tableData.map((row, index) => (
          <tr key={index}>
            <td>{row.id}</td>
            <td>{row.name}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
